import React from "react";
import { keyedNodes } from "@/lib/RscNodes";
import PrimaryBtn from "@/components/PrimaryBtn";
import { Icons } from "@/app/assets/shared";

interface IndustryHeaderProps {
  title: React.ReactNode;
  subtitle: string;
  description: string | React.ReactNode;
  buttonText?: string;
  buttonIcon?: string;
  mode?: "light" | "dark";
  btnMode?: "light" | "dark";
}

export default function IndustryHeader({
  title,
  subtitle,
  description,
  buttonText = "Let's Talk With Us",
  buttonIcon = Icons?.chevronBlue,
  mode = "light",
  btnMode = "dark",
}: IndustryHeaderProps) {
  return (
    <div
      className={`w-full ${mode === "light" ? "pt-[80px]" : "bg-transparent"} pb-[10px] lg:pb-[40px]`}
    >
      <div
        className={`max-w-[5000px] mx-auto ${mode === "light" ? "w-[calc(100%_-_10%)]" : "w-full"}`}
      >
        <div className="flex flex-col">
          {/* Subtitle */}
          <p
            className={`text-base font-medium uppercase tracking-tight 
          ${mode === "light" ? "text-[#00040B]" : "text-white"} mb-[20px] border-b
           border-[#636364]/20 pb-[10px]`}
          >
            {subtitle}
          </p>

          {/* Main content row */}
          <div className="flex flex-col lg:flex-row justify-between items-start">
            <div className="max-w-full lg:max-w-[70%]">
              {/* Title */}
              <h2
                className={`text-[length:var(--section-title)] font-medium clash-font leading-[1.1]
               ${mode === "light" ? "text-black" : "text-white"} mb-[30px]`}
              >
                {keyedNodes(title)}
              </h2>

              {/* Description — an HTML string is injected, anything else
                  (e.g. JSX from a caller) is rendered as children. */}
              {typeof description === "string" ? (
                <p
                  className="text-[length:var(--industry-para)] leading-[1.7] text-gray-600 max-w-[90%] lg:max-w-[80%]"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              ) : (
                <p className="text-[length:var(--industry-para)] leading-[1.7] text-gray-600 max-w-[90%] lg:max-w-[80%]">
                  {description}
                </p>
              )}
            </div>

            {/* Button */}
            <PrimaryBtn
              text={buttonText}
              dark={btnMode === "dark" ? true : false}
              iconSrc={buttonIcon}
              href={"/contact-us"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
